import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { FilterService } from 'primeng/api';
import { AuthService } from '../../../services/auth.service';
import { SnotifyService } from 'ng-snotify';
import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.scss']
})
export class UserDashboardComponent implements OnInit {
  filter: any = {
    companyId: undefined
  };
  default_filters = JSON.parse(JSON.stringify(this.filter));
  loading: boolean = false;
  disableCompany: boolean = false;
  disableLocation: boolean = false;
  user;
  companySaveTrigger: boolean = false;
  refetchCompanies: boolean = false;
  readOnly: boolean = false;
  constructor(private authService: AuthService, private snotifyService: SnotifyService, public router: Router, private modalService: ModalService) {
    this.user = this.authService.currentUser.value;
   if (this.authService.currentUser.value.userProfileId != 1 && this.authService.currentUser.value.userProfileId != 4) {
      this.readOnly = true;
    }
  }

  bindClientValues() {
    if (this.user.userProfileId != 1) {
      //user is a client, so throw them to the reports page
      if (this.user.companyId != undefined && this.user.companyId > 0) {
        this.filter.companyId = this.user.companyId;
        this.disableCompany = true;
      }

      if (this.user.locationId != undefined && this.user.locationId > 0) {
        this.filter.locationId = this.user.locationId;
        this.disableLocation = true;
        this.disableCompany = true;
      }
    }
  }

  ngOnInit(): void {
    this.bindClientValues();

  }

  onCompanyChange(company) {
    //console.log(company);

    if (company != undefined)
      this.router.navigate(['admin/companies/overview'], { queryParams: { id: company.id } });

  }

  createCompany() {
    //console.log("create customer");
    this.openModal('popup-company-add');
  }

  navigteToEngineerManagement() {
    this.router.navigate(['engineers']);
  }
  navigteToUserManagement() {
      this.router.navigate(['users']);
  }

  triggerCompanySave() {
    this.companySaveTrigger = !this.companySaveTrigger;
  }

  openModal(id) {
    //console.log("openeing modal");

    this.modalService.open(id);

  }
  cancelModal(id) {
    this.modalService.close(id);
  }
  closeCompanyModal(id) {
    this.cancelModal(id);
    this.refetchCompanies = !this.refetchCompanies;
  }

  companySave(company) {
    //console.log(company);
    if (company != null) {
      this.cancelModal('popup-company-add');
      this.refetchCompanies = !this.refetchCompanies;



    }
  }

}
